<template>
  <div class="financeDetails_page">
    <div class="title_box flex_center">
      <img src="./image/order_icon2.png" class="order_icon" />
      <div class="flex_column">
        <div class="order_title">财务明细</div>
        <div class="order_subtitle">客户财务统计</div>
      </div>
    </div>
    <div class="filter_content font">
      <span class="order_subtitle mb12">下单时间：</span>
      <el-date-picker
        v-model="filterData.timeDate"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        class="mr12 mb12"
        size="small"
        @change="getInfo(1)"
      >
      </el-date-picker>
      <el-button
        style="background-color: #00a0e9; color: #ffffff; border-color: #00a0e9"
        size="small"
        class="mb12"
        @click="getInfo(1)"
      >
        查询</el-button
      >
      <el-button
        style="background-color: #00a0e9; color: #ffffff; border-color: #00a0e9"
        size="small"
        class="mb12"
        @click="toExport"
        >导出</el-button
      >
    </div>
    <div class="content_box">
      <el-tabs
        v-model="filterData.financeRecordType"
        type="card"
        @tab-click="getInfo(1)"
      >
        <el-tab-pane label="所有明细" name="ALL"></el-tab-pane>
        <el-tab-pane label="充值" name="RECHARGE"></el-tab-pane>
        <el-tab-pane label="售后" name="REFUND"></el-tab-pane>
        <el-tab-pane label="支付" name="PAY"></el-tab-pane>
        <!-- <el-tab-pane label="返点" name="ALL4"></el-tab-pane>
        <el-tab-pane label="返冲" name="ALL5"></el-tab-pane> -->
        <el-tab-pane label="其他" name="OTHER"></el-tab-pane>
      </el-tabs>
      <div class="table_content">
        <el-table
          :data="tableData"
          style="width: 100%; max-width: 1200px"
          v-loading="loading"
        >
          <el-table-column prop="createTime" label="时间"> </el-table-column>
          <el-table-column prop="orderNo" label="关联订单"> </el-table-column>
          <el-table-column prop="financeRecordType" label="类型">
            <template slot-scope="scope">
              <div>
                {{
                  $enums.financeRecordTypeEnum.getLabelByValue(
                    scope.row.financeRecordType
                  )
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="balance" label="收入/支出"> </el-table-column>
          <el-table-column prop="userBalance" label="账户余额">
          </el-table-column>
        </el-table>
        <div class="flex_end statics" v-if="pageInfo.total > 10">
          <el-pagination
            :current-page.sync="pageInfo.pageNo"
            :page-size="pageInfo.pageSize"
            layout="total, prev, pager, next"
            :total="pageInfo.total"
            @current-change="changePage"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { financeListApi, financeListImportApi } from "../../api/index";
export default {
  data() {
    return {
      filterData: {
        timeDate: [],
        keywords: "",
        financeRecordType: "ALL",
      },
      tableData: [],
      pageInfo: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      loading: false,
    };
  },
  created() {},
  mounted() {
    this.getInfo();
  },
  methods: {
    changePage(page) {
      this.pageInfo.pageNo = page;
      this.getInfo(this.pageInfo.pageNo);
    },
    getInfo(page = 1) {
      this.pageInfo.pageNo = page;
      if (this.loading) {
        return;
      }
      this.loading = true;
      financeListApi({
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        startDate: this.filterData.timeDate
          ? this.filterData.timeDate.length === 2
            ? this.$moment(this.filterData.timeDate[0]).format(
                "YYYY-MM-DD 00:00:00"
              )
            : null
          : null,
        endDate: this.filterData.timeDate
          ? this.filterData.timeDate.length === 2
            ? this.$moment(this.filterData.timeDate[1]).format(
                "YYYY-MM-DD 23:59:59"
              )
            : null
          : null,
        financeRecordType:
          this.filterData.financeRecordType === "ALL"
            ? null
            : this.filterData.financeRecordType,
      })
        .then((res) => {
          if (res.resultStatus) {
            this.tableData = res.resultData.financeRecordList || [];
            this.pageInfo.total = res.resultData.totalNum || 0;
          } else {
            this.tableData = [];
            this.pageInfo.total = 0;
            this.$message.warning(res.errorMessage);
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toExport() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      financeListImportApi({
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        startDate:
          this.filterData.timeDate.length === 2
            ? this.$moment(this.filterData.timeDate[0]).format(
                "YYYY-MM-DD 00:00:00"
              )
            : null,
        endDate:
          this.filterData.timeDate.length === 2
            ? this.$moment(this.filterData.timeDate[1]).format(
                "YYYY-MM-DD 23:59:59"
              )
            : null,
        financeRecordType:
          this.filterData.financeRecordType === "ALL"
            ? null
            : this.filterData.financeRecordType,
      })
        .then((res) => {
          this.$convertRes2Blob(res, "财务明细导出数据");
          this.$message.success("導出成功");
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="less">
.financeDetails_page {
  width: 100%;
  min-height: 100%;
  border: 1px solid #e1e1e1;
  padding: 20px;
  box-sizing: border-box;
  .title_box {
    margin-bottom: 12px;
  }
  .width200 {
    width: 200px;
  }
  .width150 {
    width: 150px;
  }
  .content_box {
    width: 100%;
    box-sizing: border-box;
    .table_content {
      width: 100%;
      box-sizing: border-box;
    }
    .statics {
      font-size: 14px;
      font-weight: bold;
      margin-top: 12px;
    }
  }
}
.el-tabs__item {
  color: #999;
}
.el-tabs__item:hover {
  color: #00a0e9;
}
.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border: 1px solid #2f4050;
  border-bottom: 0;
}
.el-tabs__item.is-active {
  color: #000000;
}
</style>